export const CHROMEBOT_BOTHEAD_CLICK = 'chromebot:bothead-click'
export const CHROMEBOT_FEEDBACK = 'chromebot:feedback'
export const CHROMEBOT_UPDATED_PROFILE_SETTINGS =
  'chromebot:updated-profile-settings'

export const EXTENSION_CLIENT_EVENT_SOURCE = 'homebot-for-chrome'
export const EMBED_CLIENT_EVENT_SOURCE = 'listings-bot'
